import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { ListAdminManagementCompaniesDto } from "@/service/dto/admin-management-companies";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useManagerList = (params: ListAdminManagementCompaniesDto) => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANIES, params],
    queryFn: () => AdminManagementCompaniesService.getManagementCompanies(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar gestoras.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useManagerList;
